import "@/index.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "sonner";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import AdminLayout from "./components/AdminLayout";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PrimeiroAcesso from "./pages/PrimeiroAcesso";
import VerifiqueSeuEmail from "./pages/VerifiqueSeuEmail";
import Sign from "./pages/Sign";
import PublicInvoice from "./pages/PublicInvoice";
import PublicSaasCharge from "./pages/PublicSaasCharge";
import Dashboard from "./pages/Dashboard";
import Clientes from "./pages/Clientes";
import Fichas from "./pages/Fichas";
import Faturamento from "./pages/Faturamento";
import NotasFiscais from "./pages/NotasFiscais";
import NotaFiscalEditor from "./pages/NotaFiscalEditor";
import Aprovacoes from "./pages/Aprovacoes";
import Reconciliacao from "./pages/Reconciliacao";
import Relatorios from "./pages/Relatorios";
import Configuracoes from "./pages/Configuracoes";
import Financeiro from "./pages/Financeiro";
import Novidades from "./pages/Novidades";
// A Central de Ajuda carrega os 185 artigos do manual (src/data/ajuda/*).
// É muito texto para ir no bundle inicial de quem nunca abre a Ajuda, então
// as duas telas entram por code splitting, em um chunk próprio.
const Ajuda = lazy(() => import("./pages/Ajuda"));
const AjudaArtigo = lazy(() => import("./pages/AjudaArtigo"));

function AjudaSuspensa({ children }) {
  return <Suspense fallback={<div className="text-sm text-slate-400 p-2">Carregando a Ajuda...</div>}>{children}</Suspense>;
}
import Sobre from "./pages/Sobre";
import Empresas from "./pages/admin/Empresas";
import Planos from "./pages/admin/Planos";
import GestaoComercial from "./pages/admin/GestaoComercial";
import ConfiguracoesPlataforma from "./pages/admin/ConfiguracoesPlataforma";
import MonitorFiscal from "./pages/admin/MonitorFiscal";
import Roadmap from "./pages/admin/Roadmap";

function AnalystHome() { return <Clientes />; }

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/primeiro-acesso" element={<PrimeiroAcesso />} />
          <Route path="/verificar-codigo" element={<VerifiqueSeuEmail />} />
          <Route path="/sign/:token" element={<Sign />} />
          <Route path="/invoice/:token" element={<PublicInvoice />} />
          <Route path="/faturamento-saas/:token" element={<PublicSaasCharge />} />
          <Route
            path="/"
            element={<ProtectedRoute roles={["admin", "supervisor", "analista"]}><Layout /></ProtectedRoute>}
          >
            <Route index element={<ProtectedRoute roles={["admin", "supervisor"]}><Dashboard /></ProtectedRoute>} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="fichas" element={<Fichas />} />
            <Route path="aprovacoes" element={<ProtectedRoute roles={["admin", "supervisor"]}><Aprovacoes /></ProtectedRoute>} />
            <Route path="faturamento" element={<ProtectedRoute roles={["admin", "supervisor"]}><Faturamento /></ProtectedRoute>} />
            <Route path="notas-fiscais" element={<ProtectedRoute roles={["admin", "supervisor"]} feature="emissao_nfse"><NotasFiscais /></ProtectedRoute>} />
            <Route path="notas-fiscais/:id/editar" element={<ProtectedRoute roles={["admin", "supervisor"]} feature="emissao_nfse"><NotaFiscalEditor /></ProtectedRoute>} />
            <Route path="reconciliacao" element={<ProtectedRoute roles={["admin", "supervisor"]}><Reconciliacao /></ProtectedRoute>} />
            <Route path="financeiro" element={<Financeiro />} />
            <Route path="relatorios" element={<Relatorios />} />
            <Route path="configuracoes" element={<Configuracoes />} />
            <Route path="novidades" element={<Novidades />} />
            <Route path="ajuda" element={<AjudaSuspensa><Ajuda /></AjudaSuspensa>} />
            <Route path="ajuda/:slug" element={<AjudaSuspensa><AjudaArtigo /></AjudaSuspensa>} />
            <Route path="sobre" element={<Sobre />} />
          </Route>
          <Route
            path="/admin"
            element={<ProtectedRoute roles={["admin_master"]}><AdminLayout /></ProtectedRoute>}
          >
            <Route index element={<Navigate to="empresas" replace />} />
            <Route path="empresas" element={<Empresas />} />
            <Route path="planos" element={<Planos />} />
            <Route path="comercial" element={<GestaoComercial />} />
            <Route path="configuracoes" element={<ConfiguracoesPlataforma />} />
            <Route path="regulatorio" element={<MonitorFiscal />} />
            <Route path="roadmap" element={<Roadmap />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
